/**
 * Messages module translations - Statuses section
 */

const statuses = {
  approved: "Approved",
  notAccepted: "Not Accepted",
  inReview: "In Review",
  voided: "Voided",
};

export default statuses;
